import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TransactionsService } from '@http/transactions.service';
// import { Transaction } from '@interfaces/api/responses/transaction';
import { ToastrService } from 'ngx-toastr';
import { ITransaction } from '@http/interfaces/transaction';

@Component({
  selector: 'app-cancellation-transaction-modal',
  templateUrl: './cancellation-transaction-modal.component.html',
  styleUrls: ['./cancellation-transaction-modal.component.scss'],
})
export class CancellationTransactionModalComponent {
  inProgress = false;
  transaction!: ITransaction;
  onCanceled = () => {};

  constructor(
    public modalRef: BsModalRef,
    private transactionsService: TransactionsService,
    private toastr: ToastrService
  ) {}

  cancel() {
    if (!this.inProgress) {
      this.inProgress = true;
      this.transactionsService
        .cancelTransaction(this.transaction.entry_id)
        .subscribe({
          // @ts-ignore
          next: ({ status, msg }) => {
            if (status !== 'success') {
              this.toastr.error(msg);
            }
            this.modalRef.hide();
          },
          error: ({ error }) => {
            if (error.status !== 'success') {
              this.toastr.error(error.msg);
            }
            this.inProgress = false;

            this.modalRef.hide();
          },
          complete: () => {
            this.inProgress = false;
            this.onCanceled?.();
          },
        });
    }
  }

  hide() {
    if (!this.inProgress) {
      this.modalRef.hide();
    }
  }
}
